import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../../../api';

import LoadingOverlay from '../../common/LoadingOverlay';

function EmailPreviewModal({ partnerEmailId, onHide }) {
    const { t } = useTranslation();
    const [preview, setPreview] = useState(false);

    useEffect(() => {
        api.email.getEmailPreview(partnerEmailId)
            .then(response => {
                setPreview(response.data);
            });
    }, [partnerEmailId]);

    return (
        <Modal
            show
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                {preview ?
                    <div
                        style={{ width: '100%' }}
                        dangerouslySetInnerHTML={{
                            __html: `
                                <style>
                                    .webkit { max-width: none !important }
                                </style>
                                ${preview}
                            `
                        }}
                    />
                :
                    <div style={{ position: 'relative', minHeight: 300 }}>
                        <LoadingOverlay />
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" variant="default" onClick={() => onHide()}>
                    {t('general.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EmailPreviewModal;